// Recovery operation IDs survive a lost HTTP response and a page reload. Only
// job/item identifiers are stored; consent itself is validated by the backend.
const OPERATIONS_KEY = 'v3BatchDataRecoveryOperations';
const JOBS_KEY = 'v3BatchDataRecoveryJobs';

function readStored(key, fallback) {
  try {
    const value = JSON.parse(window.localStorage.getItem(key));
    return value && (Array.isArray(fallback) ? Array.isArray(value) : typeof value === 'object' && !Array.isArray(value)) ? value : fallback;
  }
  catch (_) { return fallback; }
}

function writeStored(key, value) {
  try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (_) { /* Private browsing. */ }
}

function createOperationId() {
  const crypto = typeof window === 'undefined' ? null : window.crypto;
  if (typeof crypto?.randomUUID === 'function') return crypto.randomUUID();
  if (typeof crypto?.getRandomValues !== 'function') throw new Error('This browser cannot create a recovery operation ID. Use a current browser.');
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

function operationIdFor(registry, action, jobId, itemIds = []) {
  const key = JSON.stringify([action, jobId, [...itemIds].sort()]);
  if (!registry[key]) {
    registry[key] = createOperationId();
    writeStored(OPERATIONS_KEY, registry);
  }
  return registry[key];
}

function canRetry(item) {
  return item.eligibleForPaidRetry === true && !item.activeLease && !item.hasSavedResponse
    && !item.completedOutcome && !item.needsReconciliation;
}

function retryCandidates(items = []) {
  const seen = new Set();
  return items.filter((item) => {
    if (!canRetry(item) || !item.jobId || !item.jobItemId || !item.ownerUniqueId || seen.has(item.ownerUniqueId)) return false;
    seen.add(item.ownerUniqueId);
    return true;
  });
}

function groupItemsByJob(items) {
  const groups = {};
  for (const item of items) (groups[item.jobId] ||= []).push(item.jobItemId);
  return groups;
}

module.exports = { OPERATIONS_KEY, JOBS_KEY, readStored, writeStored, operationIdFor,
  canRetry, retryCandidates, groupItemsByJob };
